const APPLICATIONS_REFRESH_MS = [0, 15_000, 30_000, 60_000, 120_000] as const;

export type ApplicationsRefreshMs = (typeof APPLICATIONS_REFRESH_MS)[number];

export const DEFAULT_APPLICATIONS_REFRESH_MS: ApplicationsRefreshMs = 30_000;

const STORAGE_KEY = "play-admin.applications-refresh-ms";

export function parseApplicationsRefreshMs(
	raw: unknown,
): ApplicationsRefreshMs {
	if (raw == null || raw === "") {
		return DEFAULT_APPLICATIONS_REFRESH_MS;
	}
	const value = typeof raw === "number" ? raw : Number(raw);
	return (APPLICATIONS_REFRESH_MS as readonly number[]).includes(value)
		? (value as ApplicationsRefreshMs)
		: DEFAULT_APPLICATIONS_REFRESH_MS;
}

export function readApplicationsRefreshMs(): ApplicationsRefreshMs {
	try {
		return parseApplicationsRefreshMs(window.localStorage.getItem(STORAGE_KEY));
	} catch {
		return DEFAULT_APPLICATIONS_REFRESH_MS;
	}
}

export function persistApplicationsRefreshMs(ms: ApplicationsRefreshMs) {
	try {
		window.localStorage.setItem(STORAGE_KEY, String(ms));
	} catch {
		/* ignore quota / private mode */
	}
}
